import { useRollCompetition } from '@/hooks/roll-point/useRollCompetition';
import { RollCompetitionContentTabs } from '../Tabs/props';
import RollCompetitionContentRendererInfo from './Info';
import RollCompetitionContentRendererMyAwards from './MyAwards';

export default function RollCompetitionContentRenderer() {
  const { currentTab } = useRollCompetition();

  switch (currentTab) {
    case RollCompetitionContentTabs.Information:
      return <RollCompetitionContentRendererInfo />;
    case RollCompetitionContentTabs.LastRewards:
      return <RollCompetitionContentRendererMyAwards />;
  }
}
